import {ProductsEnum} from "@falcon/services";
import {StorageSuccessModal} from "./StorageSuccessModal";
import * as React from "react";

interface IProps {
    automaticRenewal: boolean;
    nextYearRenewal: boolean;
    product: ProductsEnum;
    closeSuccessModal: () => void;
}
interface IState {

}

export class AutomaticRenewalSuccessModal extends React.Component<IProps, IState> {
    public render() {
        const product = this.props.product === ProductsEnum.HOME ? "home" : "car";
        return (
            <>
                {(this.props.automaticRenewal || this.props.nextYearRenewal) && <StorageSuccessModal
                    title="All done!"
                    explanationWording={
                    <>
                        <p className="font-weight-bold">
                            You have set up your {product} policy to renew next year.<br/>
                            You do not need to inform us of the change by email or do anything else.
                        </p>
                        <p>We'll let you know your new price and cover details in plenty of time before your renewal date and you can opt out any time you like, free of charge.</p>
                    </>
                    }
                    anythingElseTitle="Has anything else changed?"
                    explanationAnythingElseWording="Please check everything’s still accurate and make any changes required so you can be sure all policy details are up to date."
                    onClose={this.onClose}
                />}
                {!this.props.automaticRenewal && !this.props.nextYearRenewal && <StorageSuccessModal
                    title="Important Message!"
                    explanationWording={
                    <>
                        <p className="font-weight-bold">
                            You have opted out of auto-renewal.<br/>
                        </p>
                        <p>
                            Your policy will now end on the policy expiry date.<br/>
                            You can find your policy expiry date in the Policy Summary tab.<br/>
                            You do not need to inform us of the change by email or do anything else.<br/>
                            You may still receive a renewal invite and renewal date reminders.<br/>
                        </p>
                    </>}
                    anythingElseTitle=""
                    explanationAnythingElseWording=""
                    onClose={this.onClose}
                />}
            </>
        );
    }

    private onClose = (): void => {
        this.props.closeSuccessModal();
    }
}



// WEBPACK FOOTER //
// ./src/components/modals/AutomaticRenewalSuccessModal.tsx